// removed by extract-text-webpack-plugin
module.exports = {"line":"_1B1ORLBDs1iU2TiMnZyU_A","form":"_1YcC_HRJWF3z9faOL5UmI2","section":"_1S5a7BFJKieGZ0wE3-vzXE","first":"_3WusthFrnyOWhkOFjC2fGl","inline":"_1BnHLLCoSFnn3vx8choxkY","inlineItem":"s512vefIcm-R79gSv7yAK","actions":"_3awrYzA_P5hJzK8WSkWUo3"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/OverseaCard/OverseaCardForm.module.less
// module id = 776
// module chunks = 0